<template>
  <!-- Card 86akqxu0h: destaque na página inicial enquanto houver formulário
       pendente. Não bloqueia nada; some quando tudo estiver respondido. -->
  <div v-if="items.length" class="ps-card" :style="{ borderColor: color }">
    <div class="ps-head">
      <v-icon size="22" :color="color">mdi-clipboard-text-outline</v-icon>
      <div>
        <div class="ps-title">
          {{ $tc("surveys.youHave", items.length, { count: items.length }) }}
        </div>
        <div class="ps-sub">{{ $t("surveys.helps") }}</div>
      </div>
    </div>

    <div class="ps-list">
      <div v-for="item in items" :key="item.id" class="ps-item">
        <div class="ps-item__main">
          <span class="ps-badge">{{ $t("surveys.pending") }}</span>
          <span class="ps-item__title">{{ item.title }}</span>
          <span v-if="item.closesAt" class="ps-item__due">
            {{ $t("surveys.until", { date: item.closesAt.slice(0, 10) }) }}
          </span>
        </div>
        <v-btn depressed rounded small dark :color="color" @click="open(item)">
          {{ item.draftSavedAt ? $t("common.continue") : $t("surveys.answer") }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { classThemes } from "@/shared/classThemes";
import {
  SURVEYS_REFRESH_EVENT,
  loadPendingSurveys,
  surveyPath,
} from "./surveyEvents";

export default {
  name: "PendingSurveysCard",

  props: {
    profile: {
      type: String,
      default: "customer",
      validator: (value) => ["customer", "partner"].includes(value),
    },
  },

  data() {
    return { items: [] };
  },

  computed: {
    color() {
      return classThemes[this.profile]?.primary || "#A826E1";
    },
  },

  mounted() {
    this.load();
    window.addEventListener(SURVEYS_REFRESH_EVENT, this.load);
  },

  beforeDestroy() {
    window.removeEventListener(SURVEYS_REFRESH_EVENT, this.load);
  },

  methods: {
    async load() {
      this.items = await loadPendingSurveys(this.profile);
    },
    open(item) {
      this.$router.push(surveyPath(this.profile, item.id)).catch(() => null);
    },
  },
};
</script>

<style scoped>
.ps-card {
  margin-bottom: 20px;
  padding: 18px 20px;
  border: 2px solid;
  border-radius: 16px;
  background: #fffdf5;
}

.ps-head {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
}

.ps-title {
  font-weight: 700;
  font-size: 1.05rem;
  color: var(--dk-ink, #2b2540);
}

.ps-sub {
  color: var(--dk-muted, #6b6580);
  font-size: 0.875rem;
}

.ps-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ps-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--dk-surface, #fff);
  border: 1px solid #f0ead2;
}

.ps-item__main {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.ps-badge {
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--dk-ember-wash, #fff6db);
  color: var(--dk-ember-deep, #8a6500);
  font-size: 0.75rem;
  font-weight: 700;
  white-space: nowrap;
}

.ps-item__title {
  font-weight: 600;
  color: var(--dk-ink, #2b2540);
}

.ps-item__due {
  color: var(--dk-muted, #6b6580);
  font-size: 0.8rem;
}
</style>
